import { useTranslations } from '@vocab/react';
import { AccordionItem } from 'braid-design-system';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import CategoryGroupCard from 'src/components/atoms/CategoryGroupCard/CategoryGroupCard';
import { FollowIcon } from 'src/components/atoms/Icons';
import { CATEGORY_SIDE_BAR_SIZE } from 'src/core/domain/constants';
import { getPagePaths } from 'src/core/domain/pages';
import { handleAuthCheck } from 'src/core/utils/authUtil';
import { useAnalytics } from 'src/provider/analytics';
import { useAuthStatus } from 'src/provider/auth';
import { useConfig } from 'src/provider/config';
import { useGroup } from 'src/provider/group';
import { useLoginModal } from 'src/provider/loginModal';
import { usePage } from 'src/provider/page';

import translations from './.vocab';

import * as styles from './Sidebar.css';

export default () => {
  const { t } = useTranslations(translations);
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(true);
  const { isAuthenticated } = useAuthStatus();
  const { trackAnalyticsInteraction } = useAnalytics();
  const {
    groupState: { sideBarMyGroupCategory },
  } = useGroup();
  const {
    pageState: { pageName, groupId: selectedGroupId },
    pageDispatch,
  } = usePage();
  const { language } = useConfig();
  const { authStatus } = useAuthStatus();
  const { openLoginDialog } = useLoginModal();
  const myGroupsCategory = t('my-groups');
  const showMyGroup = t('show-my-groups');

  if (isAuthenticated && sideBarMyGroupCategory.length > 0) {
    return (
      <AccordionItem
        label={myGroupsCategory}
        id="my-groups"
        icon={
          <span style={{ paddingRight: '10px' }}>
            <FollowIcon />
          </span>
        }
        expanded={expanded}
        onToggle={() => setExpanded(!expanded)}
      >
        {sideBarMyGroupCategory.map(
          ({ categoryId, name: categoryName, groupId, memberCount, url }) => (
            <a
              key={categoryId}
              href={url}
              className={
                pageName === 'CommunityGroupDetails' &&
                categoryId === selectedGroupId
                  ? styles.SelectedGroupThreadsSidebar
                  : styles.GroupThreadsSidebar
              }
              onClick={() => {
                pageDispatch({ type: 'IS_LOADING' });
                pageDispatch({
                  type: 'SET_GROUP_ID',
                  payload: { groupId: categoryId },
                });
              }}
              data-testid={`sidebar-group-${categoryId}`}
            >
              <CategoryGroupCard
                key={groupId}
                category={categoryName}
                numberFollower={memberCount.label}
              />
            </a>
          ),
        )}
        {sideBarMyGroupCategory.length === CATEGORY_SIDE_BAR_SIZE && (
          <a
            href={
              getPagePaths({ language, queryParams: { type: 'my-groups' } })
                .CommunityGroups
            }
            className={styles.SidebarLinks}
          >
            {showMyGroup}
          </a>
        )}
      </AccordionItem>
    );
  }
  return (
    <a
      className={
        pageName === 'CommunityMyGroups'
          ? styles.SelectedSidebarFollowingPage
          : styles.SidebarFollowingPage
      }
      href={
        getPagePaths({ language, queryParams: { type: 'my-groups' } })
          .CommunityGroups
      }
      onClick={(e) => {
        e.preventDefault();
        if (
          handleAuthCheck({
            authStatus,
            openLoginDialog,
            trackAnalyticsInteraction,
          })
        ) {
          navigate(
            getPagePaths({ language, queryParams: { type: 'my-groups' } })
              .CommunityGroups,
          );
          pageDispatch({
            type: 'SET_PAGE_NAME',
            payload: { pageName: 'CommunityMyGroups' },
          });
        }
      }}
    >
      <CategoryGroupCard category={myGroupsCategory} icon={<FollowIcon />} />
    </a>
  );
};
